angular.module('filters').filter('formatDateTime', ["$filter", function($filter) {
  return function(input) {
    if (input) {
      return $filter('date')(input, 'medium');
    }
  };
}]);
